// extracted by mini-css-extract-plugin
export default {"actions":"InvitePrivateLeague_actions__Wr0w7","btn":"InvitePrivateLeague_btn__CPQKy","hint":"InvitePrivateLeague_hint__c+iW0"};